// extracted by mini-css-extract-plugin
export default {"loader":"EWalletWithdraw_loader__t88R4","noData":"EWalletWithdraw_noData__h-0h-"};